import { useEffect, useMemo, useRef, useState } from "react";
import "../../../assets/css/Attendance.css";
import AdvanceTable from "../../../Utils/AdvanceTables"
import { useNavigate } from "react-router-dom";
import SearchingBar from "../../../Utils/Searching";
import SpinnerLoader from "../../../Utils/Spinner";
import { formatDateDDMMYYYY } from "../../../Utils/data&dateTime";
import { HolidayShortDetails } from "./HolidayShortDetails";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { CustomToolbar } from "./CustomHeaderCalender";
import HolidayNoticePrint from "../../../Component/Modals/HolidayNoticePrint";

const HolidaysAndWorkingDaysDashboard = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filtermodal, setfiltermodal] = useState(false);
    const handleFilterClick = () => {
        setfiltermodal(true);
    };
    const [selectedHoliday, setSelectedHoliday] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [scheduledFeeData, setScheduledFeeData] = useState([])
    const [modalMode, setModalMode] = useState('create');
    const [filterScheduledFee, setFilterScheduledFee] = useState([])
    const [filterQueryString, setFilterQueryString] = useState('');
    const navigate = useNavigate();
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [filterLoading, setFilterLoading] = useState(false);

    const [viewMode, setViewMode] = useState("list");

    const localizer = momentLocalizer(moment);

    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);


    const handlePageChange = () => {

    }


    const handleRowClick = async (id, row) => {
        try {
            const selectedOrg = row?.original;
            setSelectedHoliday(selectedOrg)

        } catch (error) {

        }
    };


    const [showPrintNoticeModal, setShowPrintNoticeModal] = useState(false);
    const handlePrintNotice = (row) => {

        setSelectedHoliday(row.original || []);
        setShowPrintNoticeModal(true);
    }



    const columns = useMemo(
        () => [
            {
                Header: "Holiday Name",
                accessor: 'holidayName',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleRowClick(row?.original?.id, row)}
                        >
                            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                                {row?.original?.holidayName}
                            </p>
                        </div>
                    );
                }
            }
            ,
            {
                Header: "Holiday Type",
                accessor: 'holidayType',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                    >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.holidayType}
                        </p>

                    </div>
                ),
            },

            {
                Header: () => <p style={{ textAlign: 'start' }}>Approved By</p>,
                accessor: 'approvedBy',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div >
                        <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>{row.original.approvedBy}</p>
                    </div>
                )
            },

            // {
            //     Header: () => <p style={{ textAlign: 'start' }}>Apllied For</p>,
            //     accessor: 'applyFor',
            //     disableSortBy: true,
            //     Cell: ({ row }) => (
            //         <div >
            //             <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>{row.original.applyFor}</p>
            //         </div>
            //     )
            // },

            {
                Header: () => <p style={{ textAlign: 'start' }}>From Date</p>,
                accessor: 'fromDate',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const rawDate = row.original.fromDate;
                    return (
                        <div>
                            <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>
                                {formatDateDDMMYYYY(rawDate)}
                            </p>
                        </div>
                    );
                }
            },

            {
                Header: () => <p style={{ textAlign: 'start', }}>To Date</p>,
                accessor: 'toDate',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const rawDate = row.original.toDate;
                    return (
                        <div>
                            <p style={{ textAlign: 'start', color: '#222F3E', margin: 0 }}>
                                {formatDateDDMMYYYY(rawDate)}
                            </p>
                        </div>
                    );
                }
            },
            {
                Header: () => <p style={{ textAlign: 'start', }}>Status</p>,
                accessor: 'status',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const value = row.original.status;
                    return (
                        <span
                            style={{
                                color: value ? "green" : "orange",
                                fontWeight: "500"
                            }}
                        >
                            {value ? "Approved" : "Pending"}
                        </span>
                    );
                }
            },
            {
                Header: 'Action',
                Cell: ({ row }) => {
                    const status = row.original.status;

                    return (
                        <div style={{ display: 'flex', gap: '10px' }}>
                            {/* Resend OTP if status is false */}
                            {!status && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    width="24"
                                    height="24"
                                    fill="#7F56DA"
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // handleResendOtp(row.original.id);
                                    }}
                                    title="Resend OTP"
                                >
                                    <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" />
                                </svg>
                            )}

                            {/* Print Icon - show only if status is true */}
                            {status && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#7F56DA"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handlePrintNotice(row);
                                    }}
                                    data-tooltip-id="admission-tip"
                                    data-tooltip-content="Print Notice"
                                >
                                    <path d="M6 9V2h12v7" />
                                    <path d="M6 18H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
                                    <rect x="6" y="14" width="12" height="8" />
                                    <title>Print Notice</title>
                                </svg>
                            )}
                        </div>
                    );
                }
            }

        ],
        []
    );

    const formattedData = [
        {
            id: 1,
            holidayName: "New Session Inauguration",
            holidayType: "Institutional Event",
            approvedBy: "Principal Office",
            fromDate: "2025-10-01T00:00:00",
            toDate: "2025-10-01T23:59:59",
            applyFor: "All",
            status: true,
            handleRowClick,
        },
        {
            id: 2,
            holidayName: "Gandhi Jayanti",
            holidayType: "National Holiday",
            course: "B.A",
            semester: "Semester 3rd",
            section: "A",
            approvedBy: "Dean Office",
            fromDate: "2025-10-02T00:00:00",
            toDate: "2025-10-02T23:59:59",
            applyFor: "All",
            status: true,
            handleRowClick,
        },
        {
            id: 3,
            holidayName: "Mid-Sem Exam Break",
            course: "B.Sc",
            semester: "Semester 2nd",
            section: "A",
            holidayType: "Exam Break",
            approvedBy: "Academic Office",
            fromDate: "2025-10-03T00:00:00",
            toDate: "2025-10-05T23:59:59",
            applyFor: "Course Wise",
            status: false,
            handleRowClick,
        },
        {
            id: 4,
            holidayName: "Faculty Development Workshop",
            holidayType: "Professional Development",
            approvedBy: "HR Department",
            fromDate: "2025-10-08T00:00:00",
            toDate: "2025-10-09T23:59:59",
            applyFor: "Teacher Wise",
            teachers: [
                { teacherName: "Dr. Aditi Verma", teacherCode: "TCH-FAC01" },
                { teacherName: "Prof. Manoj Singh", teacherCode: "TCH-FAC02" },
            ],
            status: true,
            handleRowClick,
        },
        {
            id: 5,
            holidayName: "Cultural Fest - UTSAV 2025",
            holidayType: "Cultural Event",
            approvedBy: "Principal",
            fromDate: "2025-10-11T00:00:00",
            toDate: "2025-10-12T23:59:59",
            applyFor: "All Students",
            status: true,
            handleRowClick,
        },
        {
            id: 6,
            holidayName: "Research Paper Presentation",
            holidayType: "Academic Event",
            approvedBy: "Academic Office",
            fromDate: "2025-10-14T00:00:00",
            toDate: "2025-10-14T23:59:59",
            applyFor: "Teacher Wise",
            teachers: [
                { teacherName: "Dr. Sunil Mehta", teacherCode: "TCH-RS01" },
                { teacherName: "Prof. Neha Kapoor", teacherCode: "TCH-RS02" },
            ],
            status: true,
            handleRowClick,
        },
        {
            id: 7,
            holidayName: "Midterm Vacation",
            holidayType: "Vacation Break",
            approvedBy: "Dean Office",
            fromDate: "2025-10-17T00:00:00",
            toDate: "2025-10-18T23:59:59",
            applyFor: "All Students",
            status: true,
            handleRowClick,
        },
        {
            id: 8,
            holidayName: "Teacher Orientation Program",
            holidayType: "Training Workshop",
            approvedBy: "HR Department",
            fromDate: "2025-10-20T00:00:00",
            toDate: "2025-10-21T23:59:59",
            applyFor: "Teacher Wise",
            teachers: [
                { teacherName: "Prof. Ramesh Nair", teacherCode: "TCH-OR01" },
                { teacherName: "Dr. Pooja Sharma", teacherCode: "TCH-OR02" },
            ],
            status: true,
            handleRowClick,
        },
        {
            id: 9,
            holidayName: "Annual Sports Day",
            holidayType: "Institutional Event",
            approvedBy: "Principal",
            fromDate: "2025-10-23T00:00:00",
            toDate: "2025-10-23T23:59:59",
            applyFor: "All",
            status: true,
            handleRowClick,
        },
        {
            id: 10,
            holidayName: "Diwali Celebration",
            course: "B.A",
            semester: "Semester 3rd",
            section: "A",
            holidayType: "Festival Holiday",
            approvedBy: "Dean Office",
            fromDate: "2025-10-27T00:00:00",
            toDate: "2025-10-30T23:59:59",
            applyFor: "Course Wise",
            status: false,
            handleRowClick,
        },
    ];




    const [currentView, setCurrentView] = useState("month");

    // Convert formattedData → events for calendar



    const calendarEvents = formattedData.map(h => ({
        id: h.id,
        title: h.holidayName,
        start: new Date(h.fromDate),
        end: new Date(h.toDate),
        allDay: true,
        resource: h
    }));



    const handleDateClick = (clickedDate) => {
        if (!clickedDate) return;

        // Normalize clicked date to start of day
        const clicked = new Date(clickedDate);
        clicked.setHours(0, 0, 0, 0);

        const foundHoliday = formattedData.find((holiday) => {
            const from = new Date(holiday.fromDate);
            const to = new Date(holiday.toDate);

            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999); // Ensure end of day coverage

            return clicked >= from && clicked <= to;
        });

        setSelectedHoliday(foundHoliday || null);
    };




    return (
        <>
            {/* {isLoading ? (
                <SpinnerLoader />
            ) : */}

            <div className="dashboard">
                {/* Content for the Dashboard */}

                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                    <div >
                        <h2 className='main-heading'>Manage Holidays</h2>
                    </div>
                </div >
                <div className='row'>
                    <div className="col-md-12 d-flex justify-content-end " style={{ gap: '15px' }}>


                    </div>
                    <div className="row mt-2">

                        {
                            /* {showPendingFees ? (
                                <div className="col-md-12">
                                    <PendingFees onClose={() => setShowPendingFees(false)} />
                                </div>
                            ) : ( */
                            <>
                                <div className="col-md-9">
                                    <div className="row" style={{ alignItems: 'center' }}>
                                        {/* <div className="col-md-6">

                                    </div> */}
                                        <div className="col-md-12">
                                            <div style={{ display: "flex", justifyContent: 'end', gap: "12px" }}>

                                                <SearchingBar
                                                    placeholder="Search..."
                                                    url="/finance/course-fee-schedule/"
                                                    filterQueryString={filterQueryString}
                                                    // setResults={handleSetSearchResults}
                                                    ref={searchInputRef}
                                                    setTotalCount={setTotalCount}
                                                    setFilterQueryString={setFilterQueryString}
                                                    setSearchLoading={setSearchLoading}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                                {/* <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginLeft: '15px' }}>
                                            Filters if needed 
                                            </div> */}

                                                {/* <button
                                                className="filter-btn"
                                                style={{ background: 'white', border: '1px solid black', height: '43px' }}
                                                onClick={handleExportExcel}
                                            >
                                                <img src={exporticon} alt="Export" />
                                            </button> */}

                                                <div style={{ display: "flex", gap: "8px" }}>

                                                    {/* List View Button */}
                                                    <span
                                                        onClick={() => setViewMode("list")}
                                                        title="Switch to List View"
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            padding: "5px",
                                                            border: viewMode === "list" ? "2px solid #7F56DA" : "2px solid transparent",
                                                            borderRadius: "6px",
                                                            backgroundColor: viewMode === "list" ? "#f0e6ff" : "#f9f9f9", // active vs inactive background
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="30"
                                                            height="30"
                                                            viewBox="0 0 24 24"
                                                            stroke="#7F56DA"
                                                            fill="none"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <line x1="8" y1="6" x2="21" y2="6" />
                                                            <line x1="8" y1="12" x2="21" y2="12" />
                                                            <line x1="8" y1="18" x2="21" y2="18" />
                                                            <line x1="3" y1="6" x2="3" y2="6" />
                                                            <line x1="3" y1="12" x2="3" y2="12" />
                                                            <line x1="3" y1="18" x2="3" y2="18" />
                                                        </svg>
                                                    </span>
                                                    {/* Calendar View Button */}
                                                    <span
                                                        onClick={() => setViewMode("calendar")}
                                                        title="Switch to Calendar View"
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            padding: "5px",
                                                            border: viewMode === "calendar" ? "2px solid #7F56DA" : "2px solid transparent",
                                                            borderRadius: "6px",
                                                            backgroundColor: viewMode === "calendar" ? "#f0e6ff" : "#f9f9f9", // active vs inactive background
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="30"
                                                            height="30"
                                                            viewBox="0 0 24 24"
                                                            stroke="#7F56DA"
                                                            fill="none"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                            <line x1="16" y1="2" x2="16" y2="6" />
                                                            <line x1="8" y1="2" x2="8" y2="6" />
                                                            <line x1="3" y1="10" x2="21" y2="10" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <button className='add-btn' onClick={() => navigate('/add-holidays')} style={{ padding: '10px 25px' }}>
                                                    <span className="me-2">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="22"
                                                            height="22"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                            <line x1="16" y1="2" x2="16" y2="6" />
                                                            <line x1="8" y1="2" x2="8" y2="6" />
                                                            <line x1="3" y1="10" x2="21" y2="10" />
                                                            <line x1="12" y1="14" x2="12" y2="20" />
                                                            <line x1="9" y1="17" x2="15" y2="17" />
                                                        </svg>


                                                    </span>
                                                    Add Holiday
                                                </button>


                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            {/* { filterLoading ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '60vh',
                                                    paddingLeft: '28%',
                                                    borderRadius: '8px',
                                                    // backgroundColor: 'red',
                                                }}
                                            >
                                                <SpinnerLoader />
                                            </div> */}
                                            {/* )
                                            : formattedData && formattedData?.length > 0 ? ( */}


                                            {viewMode === "list" ? (
                                                <AdvanceTable
                                                    columns={columns}
                                                    pageCounts={pageCounts}
                                                    handlePageChange={handlePageChange}
                                                    selectedOrgDetails={selectedHoliday}
                                                    data={formattedData}
                                                    handleRowClick={handleRowClick}
                                                    currentPage={currentPage}
                                                    checkbox={false}
                                                />
                                            ) : (
                                                <Calendar
                                                    localizer={localizer}
                                                    events={calendarEvents}
                                                    startAccessor="start"
                                                    endAccessor="end"
                                                    style={{ height: 700 }}
                                                    views={["month", "week", "day", "agenda"]}
                                                    view={currentView}
                                                    onView={setCurrentView}
                                                    components={{
                                                        toolbar: CustomToolbar,
                                                        month: {
                                                            dateHeader: ({ date }) => {
                                                                if (!date) return null;

                                                                const today = new Date();
                                                                today.setHours(0, 0, 0, 0);

                                                                const cellDate = new Date(date);
                                                                cellDate.setHours(0, 0, 0, 0);

                                                                const isToday = cellDate.getTime() === today.getTime();

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontWeight: isToday ? "bold" : "normal",
                                                                            fontSize: isToday ? "18px" : "14px",
                                                                            width: "100%",
                                                                            height: "100%",
                                                                        }}
                                                                    >
                                                                        {cellDate.getDate()}
                                                                    </div>
                                                                );
                                                            },
                                                        },
                                                    }}
                                                    tooltipAccessor={(event) => `${event.resource?.holidayType || ""}`}
                                                    eventPropGetter={(event, start, end, isSelected) => {
                                                        const type = event.resource?.holidayType?.toLowerCase() || "";

                                                        // Light colors for normal views
                                                        let lightColors = {
                                                            holiday: "#81C784",      // Medium Light Green  
                                                            conference: "#FFB74D",   // Medium Light Orange  
                                                            exam: "#E57373",         // Medium Light Red  
                                                            workshop: "#64B5F6",     // Medium Light Blue  
                                                            training: "#64B5F6",     // Medium Light Blue  
                                                            event: "#9575CD",        // Medium Light Purple  
                                                            vacation: "#A1887F",     // Medium Light Brown  
                                                            default: "#7F56DA"
                                                        };

                                                        // Dark colors for Agenda view
                                                        let darkColors = {
                                                            holiday: "#388E3C",      // Dark Green
                                                            conference: "#F57C00",   // Dark Orange
                                                            exam: "#D32F2F",         // Dark Red
                                                            workshop: "#1976D2",     // Dark Blue
                                                            training: "#1976D2",     // Dark Blue
                                                            event: "#7B1FA2",        // Dark Purple
                                                            vacation: "#5D4037",     // Dark Brown
                                                            default: "#5E35B1"
                                                        };

                                                        // Select color set based on current view
                                                        const colors = currentView === "agenda" ? darkColors : lightColors;

                                                        let color = colors.default;
                                                        if (type.includes("holiday")) color = colors.holiday;
                                                        else if (type.includes("conference")) color = colors.conference;
                                                        else if (type.includes("exam")) color = colors.exam;
                                                        else if (type.includes("workshop") || type.includes("training")) color = colors.workshop;
                                                        else if (type.includes("event")) color = colors.event;
                                                        else if (type.includes("vacation")) color = colors.vacation;

                                                        const today = new Date();
                                                        today.setHours(0, 0, 0, 0);
                                                        const eventDate = new Date(event.start);
                                                        eventDate.setHours(0, 0, 0, 0);
                                                        const isToday = eventDate.getTime() === today.getTime();
                                                        const isHoliday = type.includes("holiday");

                                                        const baseStyle = {
                                                            border: `2px solid ${color}`,
                                                            borderRadius: "6px",
                                                            fontWeight: "500",
                                                            fontSize: "13px",
                                                            padding: "2px 6px",
                                                            color: "white",
                                                            backgroundColor: color
                                                        };

                                                        if (["agenda", "day"].includes(currentView)) {
                                                            return { style: { ...baseStyle, backgroundColor: "transparent", color: color } };
                                                        }

                                                        if (["week"].includes(currentView)) {
                                                            return { style: baseStyle };
                                                        }

                                                        return { style: baseStyle };
                                                    }}



                                                    dayPropGetter={(date) => {
                                                        const d = new Date(date);
                                                        d.setHours(0, 0, 0, 0);

                                                        const today = new Date();
                                                        today.setHours(0, 0, 0, 0);

                                                        const isToday = d.getTime() === today.getTime();

                                                        const hasHoliday = calendarEvents.some((ev) => {
                                                            const s = new Date(ev.start).setHours(0, 0, 0, 0);
                                                            const e = new Date(ev.end).setHours(0, 0, 0, 0);
                                                            return d >= s && d <= e;
                                                        });

                                                        if (currentView === "month") {
                                                            if (isToday) {
                                                                return {
                                                                    style: {
                                                                        background: "linear-gradient(145deg, rgb(211 204 221), rgb(187 173 223))",
                                                                        border: "2px solid rgb(163 134 222)",
                                                                        borderRadius: "10px",
                                                                        cursor: hasHoliday ? "pointer" : "default",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.4)",
                                                                    }
                                                                };
                                                            }

                                                            if (hasHoliday) {
                                                                return {
                                                                    style: {
                                                                        cursor: "pointer",
                                                                        // border: "1px solid #b68ce0",
                                                                        // borderRadius: "2px",
                                                                        // backgroundColor: "#f3e5f5", // optional for visual
                                                                    }
                                                                };
                                                            }

                                                            return {};
                                                        }

                                                        if (currentView === "week") {
                                                            if (isToday) {
                                                                return {
                                                                    style: {
                                                                        background: "linear-gradient(145deg, rgb(211 204 221), rgb(187 173 223))",
                                                                        border: "2px solid rgb(163 134 222)",
                                                                        borderRadius: "10px",
                                                                        color: "white",
                                                                        fontWeight: "bold",
                                                                        fontSize: "20px",
                                                                        cursor: hasHoliday ? "pointer" : "default",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.4)",
                                                                    }
                                                                };
                                                            } else if (hasHoliday) {
                                                                return {
                                                                    style: {
                                                                        cursor: "pointer",
                                                                        border: "1px solid #b68ce0",
                                                                        borderRadius: "2px",
                                                                        // backgroundColor: "#f3e5f5" // Light purple for holidays
                                                                    }
                                                                };
                                                            }
                                                            return {};
                                                        }

                                                        if (currentView === "day") {
                                                            return {
                                                                style: {
                                                                    border: "2px solid #b68ce0",
                                                                    borderRadius: "2px",
                                                                    backgroundColor: "transparent",
                                                                    cursor: hasHoliday ? "pointer" : "default",
                                                                }
                                                            };
                                                        }

                                                        return {};
                                                    }}




                                                    onSelectEvent={(event) => handleDateClick(event.start)}
                                                    onSelectSlot={(slotInfo) => handleDateClick(slotInfo.start)}
                                                    selectable
                                                />





                                            )}




                                            {/* ) : (!isLoading && !isSearchLoading && ( */}
                                            {/* <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '60vh',
                                                        color: '#888',
                                                        borderRadius: '8px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    No Fee Scheduled available.
                                                </div> */}
                                            {/* )
                                            )} */}


                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <HolidayShortDetails selectedHoliday={selectedHoliday} />
                                </div>
                            </>
                        }
                    </div>



                </div >

            </div>

            <HolidayNoticePrint
                isOpen={showPrintNoticeModal}
                selectedHoliday={selectedHoliday}
                onClose={() => setShowPrintNoticeModal(false)}
            />
            {/* } */}
        </>
    )

}
export default HolidaysAndWorkingDaysDashboard



